const mainDomain = "https://api.the3dcreator.com/";
const imageDomain = "https://api.the3dcreator.com";
// const mainDomain = "http://localhost:5050/"
// const imageDomain = "http://localhost:5050";

const Constants = {
  imgDomain: imageDomain,
  getUrls: {
    getProfile: mainDomain + "admin/profile",
    getUserList: mainDomain + "user",
    testimonials: mainDomain + "testimonial",
    getAllCategory: mainDomain + "category",
    getAllSubcategory: mainDomain + "sub-category",
    getAllProducts: mainDomain + "products",
    getAllVariants: mainDomain + "variants",
    getAllOrders: mainDomain + "order/allOrder",
    getSingleOrder: mainDomain + "order",
    generateOrderQr: mainDomain + "order/generateQR",
    dashboard: mainDomain + "dashboard",
    getenquiryList: mainDomain + "enquiry/list",
    getLeadsList: mainDomain + "leads/list",
    getbestSellingProduct: mainDomain + "products/bestSelling",
    getallBanners: mainDomain + "banner",
  },
  postUrls: {
    addProducts: mainDomain + "products/create",
    login: mainDomain + "admin/login",
    createTestimonial: mainDomain + "testimonial/create",
    Addcategory: mainDomain + "category/create",
    AddSubcategory: mainDomain + "sub-category/create",
    addVariants: mainDomain + "variants/create",
    markEnquiryAsRead: mainDomain + "enquiry/mark-as-read",
    AddBanner: mainDomain + "banner/create",
    registerNotification: mainDomain + "admin/notifications/register",
  },
  putUrls: {
    updateTestimonial: mainDomain + "testimonial/update/",
    deleteTestimonial: mainDomain + "testimonial/delete/",
    updateCategory: mainDomain + "category/update",
    updateSubCategory: mainDomain + "sub-category/update",
    updateProducts: mainDomain + "products/update",
    updateVariants: mainDomain + "variants/update",
    updateVariantsBySize: mainDomain + "variants/update-by-size",
    productStatus: mainDomain + "products/status/",
    productBestSelling: mainDomain + "products/best_selling/",
    productHideSizeColour: mainDomain + "products/hide_size_colour/",
    productHideSize: mainDomain + "products/hide_size/",
    productHideColour: mainDomain + "products/hide_colour/",
    variantStatus: mainDomain + "variants/status/",
    categoryStatus: mainDomain + "category/status/",
    subCategoryStatus: mainDomain + "sub-category/status/",
    cancelOrder: mainDomain + "order/cancel",
    orderPicked: mainDomain + "order/picked",
    updateDeliveryLink: mainDomain + "order/update-delivery-link",
    updateBanner: mainDomain + "banner/update",
    bannerStatus: mainDomain + "banner/status/",
  },
  deleteUrls: {
    deleteOrder: mainDomain + "order/delete/",
    deleteProducts: mainDomain + "products/delete",
    deleteVariants: mainDomain + "variants/delete/",
    deleteCategory: mainDomain + "category/delete/",
    deleteSubCategory: mainDomain + "sub-category/delete/",
    deleteUser: mainDomain + "user/delete/",
    deletWebEnquiry: mainDomain + "enquiry/delete/",
    deletebanner: mainDomain + "banner/delete/",
  },
};
export default Constants;
